import { MutationUpdaterFn } from "apollo-client";
import { IntlShape } from "react-intl";
import { ME } from "../../graphql/account/query";
import { Me } from "../../graphql/account/types/Me";
import { CreatePerson } from "../../graphql/person/types/CreatePerson";
import { DocumentInterface } from "../../interface/DocumentInterface";
import { FileInterface } from "../../interface/FileInterface";
import {
  PersonInterface,
  EmailShareholderInterface,
} from "../../interface/PersonInterface";
import { MESSAGE_TYPE, TreezorDocType, CIN_ENUM } from "../../utils/constant";
import { displaySnackBar } from "../../utils/snackBarUtils";
import { isAdult, isEmailValid } from "../../utils/Validator";
import SnackVariableInterface from "../../interface/SnackVariableInterface";
import { document, CreateHostInterface } from "../StepFive/utils";
import { DEFAULT_COUNTRY_CODE } from "../../constants/countries";
import {
  CreateMemberInput,
  CreateUserInput,
} from "../../types/graphql-global-types-onboarding";

export interface InputFileInterface {
  identityType: string;
  addressType: string;
  identityType2: string;
}

export const emptyInputFile: InputFileInterface = {
  identityType: "",
  identityType2: "",
  addressType: "",
};

export const emptyHost: CreateHostInterface = {
  identity: "",
  address: "",
};

export let snackBarErrorData: SnackVariableInterface = {
  type: MESSAGE_TYPE.ERROR,
  message: "",
  isOpen: true,
};
export let snackBarSuccessData: SnackVariableInterface = {
  type: MESSAGE_TYPE.SUCCESS,
  message: "",
  isOpen: true,
};

export const emptyIdentity: DocumentInterface = {
  id: "",
  uuid: "",
  filename: "",
  filetype: "",
  documentTypeId: "",
};
export const emptyAddress = { ...emptyIdentity };
export const emptyEmail = {
  id: "",
  email: "",
};
export const emptyShareholder: CreateUserInput = {
  id: "",
  address: "",
  city: "",
  cityOfBirth: "",
  countryOfBirthIsoCode: "",
  dateOfBirth: "",
  firstname: "",
  name: "",
  gender: "",
  isLegalRepresentative: true,
  nationalityCountryIsoCode: "FR",
  countryIsoCode: "FR",
  sharesPercentage: null,
  postcode: "",
  type: "UBO",
  specifiedUSPerson: null,
  documents: [],
  isDirector: false,
};
export const emptyFile: FileInterface = {
  filename: "",
  filetype: "",
  file: [],
};

export const getEmail = (
  saveEmails: EmailShareholderInterface[],
  index: number,
  isAccountId?: boolean,
): string => {
  if (isAccountId) {
    if (saveEmails && saveEmails.length && saveEmails[index]) {
      return saveEmails[index].id;
    }
  }
  let email = "";
  if (saveEmails && saveEmails.length && saveEmails[index])
    email = saveEmails[index].email;
  return email;
};

export const fieldErrorSnackBar = (
  client: any,
  intl: IntlShape,
  messageId: string,
): void => {
  displaySnackBar(client, {
    type: MESSAGE_TYPE.ERROR,
    message: intl.formatMessage({ id: messageId }),
    isOpen: true,
  });
};

export const checkShareholderEmails = (
  client: any,
  intl: IntlShape,
  emailList: EmailShareholderInterface[],
): boolean => {
  if (emailList.length > 0) {
    for (const data of emailList) {
      const { email } = data;
      if (!email) {
        fieldErrorSnackBar(client, intl, "shareholder.email.empty");
        return false;
      }
      if (!isEmailValid(email)) {
        fieldErrorSnackBar(client, intl, "account.data.email.notValid");
        return false;
      }
    }
    return true;
  }
  return true;
};

export const checkShareholderPhones = (
  client: any,
  intl: IntlShape,
  phoneList: EmailShareholderInterface[],
): boolean => {
  if (phoneList.length > 0) {
    for (const data of phoneList) {
      const { email: phone } = data;
      if (!phone) {
        fieldErrorSnackBar(client, intl, "phone.empty");
        return false;
      }
    }
    return true;
  }
  return true;
};

export const checkShareholderInputFields = (
  client: any,
  intl: IntlShape,
  shareholderList: PersonInterface[],
  inputFile: InputFileInterface[],
): boolean => {
  let i = 0;
  if (shareholderList.length > 0) {
    for (const shareholder of shareholderList) {
      const identityFile = inputFile[i].identityType;
      const addressFile = inputFile[i].addressType;
      i++;
      const {
        title,
        name,
        firstName,
        nationality,
        birthday,
        specifiedUSPerson,
        placeOfBirth,
        birthCountry,
        birthPostCode,
        address,
        postCode,
        city,
      } = shareholder;
      if (!title) {
        fieldErrorSnackBar(client, intl, "stepFive.form.empty.title");
        return false;
      }
      if (!firstName) {
        fieldErrorSnackBar(client, intl, "stepFive.form.empty.firstName");
        return false;
      }
      if (!name) {
        fieldErrorSnackBar(client, intl, "stepFive.form.empty.name");
        return false;
      }
      if (!nationality) {
        fieldErrorSnackBar(client, intl, "stepFive.form.nationality.empty");
        return false;
      }
      if (!isAdult(birthday)) {
        fieldErrorSnackBar(client, intl, "manager.birthday.notAdult");
        return false;
      }
      if (!placeOfBirth) {
        fieldErrorSnackBar(client, intl, "stepFive.form.empty.placeOfBirthday");
        return false;
      }
      if (!birthCountry) {
        fieldErrorSnackBar(client, intl, "stepFive.form.empty.birthCountry");
        return false;
      }
      if (!specifiedUSPerson) {
        fieldErrorSnackBar(client, intl, "stepFive.form.empty.usPerson");
        return false;
      }
      if (!birthPostCode) {
        fieldErrorSnackBar(client, intl, "stepFive.form.empty.birthPostCode");
        return false;
      }
      if (!identityFile) {
        fieldErrorSnackBar(client, intl, "stepFive.form.empty.identity");
        return false;
      }
      if (!address) {
        fieldErrorSnackBar(client, intl, "stepFive.form.empty.address");
        return false;
      }
      if (!postCode) {
        fieldErrorSnackBar(client, intl, "stepFive.form.empty.postCode");
        return false;
      }
      if (!city) {
        fieldErrorSnackBar(client, intl, "stepFive.form.empty.city");
        return false;
      }
      if (!addressFile) {
        fieldErrorSnackBar(client, intl, "stepFive.form.empty.addressProof");
        return false;
      }
    }
    return true;
  }
  return true;
};

export const checkShareholderFile = (
  client: any,
  intl: IntlShape,
  identityFileList: Array<FileInterface[]>,
  identityFileList2: Array<FileInterface[]>,
  addressFileList: FileInterface[],
  identityDocument: DocumentInterface[],
  vigilanceDocument: DocumentInterface[],
  addressDocument: DocumentInterface,
): boolean => {
  if (
    !!identityFileList.length &&
    !!addressFileList.length &&
    !!identityFileList2.length
  ) {
    let gotIdentityFileNb = 0;
    let gotIdentityFile2Nb = 0;
    let gotAddressFileNb = 0;
    identityFileList.map((files) => {
      gotIdentityFileNb += countNbFile(files);
    });
    identityFileList2.map((files) => {
      gotIdentityFile2Nb += countNbFile(files);
    });
    gotAddressFileNb = countNbFile(addressFileList);
    if (gotIdentityFileNb === 0 && !identityDocument.length) {
      fieldErrorSnackBar(client, intl, "stepFive.form.empty.identityFile");
      return false;
    }
    if (gotIdentityFile2Nb === 0 && !vigilanceDocument.length) {
      fieldErrorSnackBar(client, intl, "stepFive.form.empty.identityFile");
      return false;
    }
    if (gotAddressFileNb === 0 && !addressDocument.filename) {
      fieldErrorSnackBar(client, intl, "stepFive.form.empty.addressFile");
      return false;
    }
    return true;
  }
  return false;
};

const countNbFile = (fileList: FileInterface[]): number => {
  let nbFile: number = 0;
  for (const file of fileList) {
    /** if file is an array */
    const files: any = file;
    if (files && files.length) {
      for (const f of files) {
        if (f && f.filename && f.filename.length) {
          nbFile++;
        }
      }
    }
    /** if file is an object */
    if (file && file.filename && file.filename.length) {
      nbFile++;
    }
  }
  return nbFile;
};

export const formatShareholderFromDb = (
  shareholderFromDb: any,
): PersonInterface => {
  let docs: DocumentInterface[] = [];
  if (shareholderFromDb.documents) {
    docs = [...docs, ...getDoc(shareholderFromDb, TreezorDocType.IDENTITY_DOC)];
    docs = [
      ...docs,
      ...getDoc(shareholderFromDb, TreezorDocType.VIGILANCE_SUP_DOC),
    ];
    docs = [
      ...docs,
      ...getDoc(shareholderFromDb, TreezorDocType.ADDRESS_PROOF_DOC),
    ];
    docs = [
      ...docs,
      ...getDoc(shareholderFromDb, TreezorDocType.HOSTING_PROOF_ADDRESS),
    ];
    docs = [
      ...docs,
      ...getDoc(shareholderFromDb, TreezorDocType.HOSTING_PROOF_IDENTITY),
    ];
    docs = [
      ...docs,
      ...getDoc(shareholderFromDb, TreezorDocType.HOSTING_PROOF_ATTESTATION),
    ];
  }
  const formattedShareholder: PersonInterface = {
    id: shareholderFromDb.id,
    type: shareholderFromDb.type,
    title: shareholderFromDb.title,
    name: shareholderFromDb.name,
    firstName: shareholderFromDb.firstName,
    nationality: shareholderFromDb.nationality,
    specifiedUSPerson: shareholderFromDb.specifiedUSPerson,
    isPersonHosted: shareholderFromDb.isPersonHosted,
    birthday: shareholderFromDb.birthday,
    placeOfBirth: shareholderFromDb.placeOfBirth,
    birthCountry: shareholderFromDb.birthCountry,
    birthPostCode: shareholderFromDb.birthPostCode,
    address: shareholderFromDb.address,
    postCode: shareholderFromDb.postCode,
    city: shareholderFromDb.city,
    documents: [...docs.filter((d) => d && d.filename)],
  };
  return formattedShareholder;
};

export const handleUpdateCacheAfterShareholderCreation: MutationUpdaterFn<
  CreatePerson
> = (cache, mutationResult) => {
  const meData = cache.readQuery<Me>({ query: ME });
  if (meData?.me?.company?.shareholders && mutationResult?.data?.createPerson) {
    const newShareholders: any = formatShareholderFromDb(
      mutationResult.data.createPerson,
    );
    meData.me.company.shareholders = [
      ...meData.me.company.shareholders,
      {
        ...newShareholders,
        __typename: "Person",
        capital: "0",
        documents: [
          ...newShareholders.documents.map((doc: any) => {
            return { ...doc, __typename: "Document" };
          }),
        ],
      },
    ];
    cache.writeQuery<Me>({
      query: ME,
      data: meData,
    });
  }
};

export const getDoc = (
  shareholders: any,
  category: string,
  isCin?: string,
): DocumentInterface[] => {
  if (shareholders && shareholders.documents) {
    const docs = shareholders.documents.filter((doc: any) => {
      return doc?.type?.category === category;
    });
    if (docs && docs.length) {
      // if CIN document only
      if (isCin) {
        switch (isCin) {
          case CIN_ENUM.RECTO:
            if (docs[0]) {
              return [{ ...docs[0] }];
            } else {
              return [{ ...document }];
            }
          case CIN_ENUM.VERSO:
            if (docs[1]) {
              return [{ ...docs[1] }];
            } else {
              return [{ ...document }];
            }
          default:
            return [{ ...document }];
        }
      }
      // if other document
      return docs.map((d: any) => {
        if (d && d.type && d.type.id)
          return { ...d, documentTypeId: d.type.id };
      });
    }
  }
  return [{ ...document }];
};
